import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { BreadcrumbItemContext } from '../../provider/BreadcrumbItemContextProvider';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { utility } from '../../utility';
import NewsDetailSeeMoreNewsCard from './NewsDetailSeeMoreNewsCard';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version1.5 NewsDetail画面新規追加
 * NewsDetail Page Component
 */
const NewsDetail = ({ previewNewsInfo }) => {
  // 変数・State
  const screenId = 'MyM502';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList } = useWebContext(screenId);
  const [newsInfo, setNewsInfo] = useState(previewNewsInfo);
  const [seeMoreNewsList, setSeeMoreNewsList] = useState([]);
  const navigate = useNavigate();
  const queryParam = useParams();
  const { setBreadcrumbItem } = useContext(BreadcrumbItemContext);
  const [isLoading, setIsLoading] = useState(false);
  const isPc = useMediaQuery(mediaQuery.pc);

  useEffect(() => {
    // プレビュー時は処理しない
    if (previewNewsInfo) { return; }

    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestNewsDetail = async (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestNewsDetail();
        return;
      }

      // モバイル表示の場合、省略文字を設定
      const breadcrumbLink = isPc ? result.NewsInfo.Title : utility.convertEllipsisFormat(result.NewsInfo.Title, 14);
      // パンくずリストにNewsTitleを設定
      setBreadcrumbItem(breadcrumbLink);

      setNewsInfo({
        ...result.NewsInfo,
        // 画像ファイル名が指定されている場合、画像ファイル取得
        ImageFile: result.NewsInfo.ImageFileName && new File([await (await fetch(`api/news/image?newsId=${queryParam.news_id}&fileName=${result.NewsInfo.ImageFileName}`)).blob()], result.NewsInfo.ImageFileName)
      });
      setSeeMoreNewsList(result.SeeMoreNewsList);
      setIsLoading(false);
    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestNewsDetail = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }
    apiRequest.requestJson(`api/news/detail-load?newsId=${queryParam.news_id}`, 'GET', callbackSuccessRequestNewsDetail, callbackFailedRequestNewsDetail)

    // アンマウント時、パンくずリストのコンテキストをクリア
    return () => {
      setBreadcrumbItem(null);
    }
  }, []);


  if (!newsInfo)
    return <MyMProgress />

  return (
    <Box className='py-1'>
      {isLoading && <MyMProgress />}
      {
        isPc ?
          <>
            <Container sx={{ maxWidth: '1600px !important', border: '2px solid #D4D4D4' }} className='py-3 ps-5'>
              <MyMVariantLabel variant='h4' className='mb-4'>{newsInfo.Title}</MyMVariantLabel>
              {(newsInfo.PublishDate && newsInfo.PublishDate !== 'Invalid Date') && <MyMLabel className='mb-3' fontSize='14px' color='gray'>{controlSettings.LabelList.lblPublishedTitle} {utility.convertEnglishDateFormat(newsInfo.PublishDate)}</MyMLabel>}

              <Grid container>
                <Grid item xs={9}>
                  {newsInfo.ImageFile &&
                    <Box className='float-start me-4' sx={{ color: '#77787B', maxWidth: '40%' }} >
                      <img src={URL.createObjectURL(newsInfo.ImageFile)} style={{ maxWidth: '100%' }} alt='news' />
                      <MyMLabel fontSize='14px' sx={{ color: '#77787B' }}>{newsInfo.ImageCaption}</MyMLabel>
                    </Box>}
                  <Box
                    className="preview-contents text-break"
                    sx={{
                      fontSize: 'unset',
                      '*': { fontSize: '18px' },
                      'img': { maxWidth: '1000px' },
                    }}
                    dangerouslySetInnerHTML={{ __html: newsInfo.Contents }} />
                </Grid>
                <Grid item xs={3}>
                  {
                    // Preview表示ではない場合、SeeMoreNewsを表示
                    !previewNewsInfo &&
                    <NewsDetailSeeMoreNewsCard
                      screenId={screenId}
                      apiRequest={apiRequest}
                      controlSettings={controlSettings}
                      messageList={messageList}
                      newsList={seeMoreNewsList}
                      setIsLoading={setIsLoading} />
                  }
                </Grid>
              </Grid>
            </Container>
          </>
          :
          <>
            {/*モバイル版*/ }
            <Container sx={{ border: '2px solid #D4D4D4' }} className='py-3 ps-5'>
              <MyMVariantLabel variant='h5' className='mb-4'>{newsInfo.Title}</MyMVariantLabel>
              {(newsInfo.PublishDate && newsInfo.PublishDate !== 'Invalid Date') && <MyMLabel className='mb-3' fontSize='14px' color='gray'>{controlSettings.LabelList.lblPublishedTitle} {utility.convertEnglishDateFormat(newsInfo.PublishDate)}</MyMLabel>}

              <Grid container>
                <Grid container item xs={12}>
                  
                  {newsInfo.ImageFile &&
                    <Grid item xs>
                      <Box className='float-start me-4' sx={{ color: '#77787B', maxWidth: '40%' }} >
                        <Grid container>
                          <Grid item xs={12}>
                            <img src={URL.createObjectURL(newsInfo.ImageFile)} style={{ maxWidth: '100%' }} alt='news' />
                          </Grid>
                          <Grid item>
                            <MyMLabel fontSize='14px' sx={{ color: '#77787B' }}>{newsInfo.ImageCaption}</MyMLabel>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>}
                  <Grid item>
                  <Box
                    className="preview-contents text-break"
                    sx={{
                      fontSize: 'unset',
                      '*': { fontSize: '18px' },
                      'img': { maxWidth: '100%' },
                    }}
                      dangerouslySetInnerHTML={{ __html: newsInfo.Contents }} />
                  </Grid>
                </Grid>
                <Grid item xs={10.5}>
                  {
                    // Preview表示ではない場合、SeeMoreNewsを表示
                    !previewNewsInfo &&
                    <NewsDetailSeeMoreNewsCard
                      screenId={screenId}
                      apiRequest={apiRequest}
                      controlSettings={controlSettings}
                      messageList={messageList}
                      newsList={seeMoreNewsList}
                      setIsLoading={setIsLoading} />
                  }
                </Grid>
              </Grid>
            </Container>
          </>
      }

    </Box>
  );
}
export default NewsDetail;
